/**
 * Created by valerasiestov on 20.11.15.
 */

/*global TweenMax */

if (!window.module) {
    window.module = {};
}

module.tabs = (function (global) {
    "use strict";

    var controls = {},
        handlers = {
            getCurrentTab: function () {
                var list = controls.tabsTriggers,
                    count = list.length,
                    i;

                for (i = 0; i < count; i++) {
                    if (list[i].checked) {
                        return controls.tabs.querySelector('[data-id="' + list[i].getAttribute('id') + '"]')
                    }
                }
            },

            changeTabTrigger: function (id) {
                var list = controls.tabsTriggers,
                    count = list.length,
                    i;

                for (i = 0; i < count; i++) {
                    if (list[i].getAttribute('id') === id) {
                        list[i].checked = true;
                    }
                }
            },

            changeTabs: function (event) {
                event.preventDefault();

                var changeToId = event.target.getAttribute('for'),
                    changeToContent,
                    currentContent = handlers.getCurrentTab(),
                    completeCount = 2,
                    completeIndex = 0,
                    startNextStep = function () {
                        handlers.changeTabTrigger(changeToId);
                        TweenMax.to(changeToContent, 0.5, {x: '0%', opacity: 1, onComplete: function () {

                        }});
                    },

                    firstStageComplete = function () {
                        completeIndex++;

                        if (completeIndex >= completeCount) {
                            startNextStep();
                        }
                    },
                    currentHeight,
                    changeToHeight;

                changeToContent = controls.tabs.querySelector('[data-id="' + changeToId + '"]');

                if (currentContent == changeToContent) {
                    return;
                }

                TweenMax.set(changeToContent, {x: '-25%', opacity: 0});
                currentHeight = $(currentContent).height();
                changeToHeight = $(changeToContent).height();

                controls.tabsWrap.style.height = currentHeight + 'px';
                TweenMax.to(currentContent, 0.5, {x: '25%', opacity: 0, onComplete: firstStageComplete});
                TweenMax.to(controls.tabsWrap, 0.5, {
                    height: changeToHeight,
                    onComplete: firstStageComplete
                });
            }
        };

    function setEventList() {
        global.addEvents(controls.tabsControls, 'click', handlers.changeTabs);
    }

    function getControls() {
        var tabs;
        
        controls.tabs = tabs = document.querySelector('.tabs');

        if (!tabs) {
            return false;
        }

        controls.tabsWrap = tabs.querySelector('.tabs__content-list');
        controls.tabsTriggers = tabs.querySelectorAll('.trigger');
        controls.tabsControls = tabs.querySelectorAll('.tabs__header label');
        controls.tabsContent = tabs.querySelectorAll('.tabs__content');

        return true;
    }

    function init(params) {
        if (getControls()) {
            setEventList();
        }
    }

    return {
        init: init
    };

}(DALGAKIRAN.global));

window.addEventListener('DOMContentLoaded', function () {

    module.tabs.init({

    });

}, false);
